
import { DeskData } from '@/datamodel/deskdata'
import { ResponseData } from '@/datamodel/response-data'
import { TableLimit } from '@/datamodel/types'
import { DeskMoreInfoModel } from '@/datamodel/urlparams/DeskMoreInfoModel'
import { store } from '@/store'
import { DeskMutation } from '@/store/module/desk'
import { MemberLimit } from 'vue'
import { Options, Vue } from 'vue-class-component'
import { useI18n } from 'vue-i18n'
import { Prop } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

@Options({})
export default class DListItemMultiView extends Vue {
    iN = useI18n().t
    @Prop({ default: -1 }) selectedIndex!: number
    @Prop({ default: -1 }) itemIndex!: number

    @Prop({ default: new Array<DeskData>() }) desks!: Array<DeskData>
    //#region Vuex Getter
    @Getter('userLimits') userLimits!: Array<MemberLimit>
    //#endregion

    //#region Vuex Action
    @Action('showLoading') showLoading!: () => void
    @Action('hideLoading') hideLoading!: () => void
    @Action('getDeskOtherInfo') getDeskOtherInfo!: (
        model: DeskMoreInfoModel
    ) => Promise<ResponseData>
    @Action('setChipsValues') setChipsValues!: (
        chipvalues: Array<number>
    ) => void
    @Action('setCurrentDesk') setCurrentDesk!: (
        model: DeskData | undefined
    ) => void
    @Action('destroySession') destroySession!: () => void
    @Action('setDeskLimit') setDeskLimit!: (limit: TableLimit) => void
    @Action('setDeskNotice') setDeskNotice!: (notice: string) => void
    @Action('setMultiDeskTables')
    setMultiDeskTables!: (tables: Array<number>) => void
    //#endregion

    $emit: Vue['$emit']

    enterDesk(limit: MemberLimit): void {
        store.commit(DeskMutation.SET_DESK_LIMIT, limit)
        this.$emit('enter-table')
    }
}
